export type { NotesAndFilesSectionProps } from "./notes-and-files-section";
export { NotesAndFilesSection } from "./notes-and-files-section";
export { type ClientRecordKind, type EditableRecordKind, recordKindIcon } from "./record-kind";
